import { useId, useState } from "react";
import "./EnergyInsight.css";

// 제목 옆 "?" — 올리거나 누르면 설명이 뜬다.
// 화면만 봐서는 모르는 것(큐브 전체 합계 · fog · edge 가 뭐가 다른지, 남는/모자라는 전력이 배터리에 무슨 뜻인지)을 적는 자리.
// lines 는 문단 배열(i18n 문구). 터치 화면은 hover 가 없어 누르면 열리고 다시 누르면 닫힌다. 키보드는 포커스로 연다.
export default function HelpTip({ label, lines = [] }) {
  const id = useId();
  const [open, setOpen] = useState(false);

  return (
    <span
      className={`ei-help${open ? " is-open" : ""}`}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        className="ei-help-btn"
        aria-label={label}
        aria-expanded={open}
        aria-describedby={id}
        onClick={() => setOpen((value) => !value)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
      >
        ?
      </button>
      <span id={id} role="tooltip" className="ei-help-tip" hidden={!open}>
        {lines.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </span>
    </span>
  );
}
